var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowStatusProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1785_3801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2334 12.6216L10.2534 1.97497C10.0799 1.66398 9.82656 1.40494 9.5195 1.22462C9.21244 1.04429 8.8628 0.949219 8.50671 0.949219C8.15061 0.949219 7.80097 1.04429 7.49391 1.22462C7.18685 1.40494 6.9335 1.66398 6.76004 1.97497L0.766706 12.6216C0.595338 12.9264 0.506292 13.2705 0.508335 13.6202C0.510378 13.9698 0.60344 14.3129 0.778359 14.6156C0.953278 14.9184 1.20402 15.1704 1.50591 15.3468C1.8078 15.5232 2.15042 15.6179 2.50004 15.6216H14.5C16.0267 15.6216 16.9934 13.9616 16.2334 12.6216ZM11.2067 11.915C11.394 12.1025 11.4992 12.3566 11.4992 12.6216C11.4992 12.8866 11.394 13.1408 11.2067 13.3283C11.0192 13.5156 10.765 13.6208 10.5 13.6208C10.235 13.6208 9.98087 13.5156 9.79337 13.3283L8.49337 12.035L7.20004 13.3283C7.01254 13.5156 6.75837 13.6208 6.49337 13.6208C6.22837 13.6208 5.97421 13.5156 5.78671 13.3283C5.59944 13.1408 5.49425 12.8866 5.49425 12.6216C5.49425 12.3566 5.59944 12.1025 5.78671 11.915L7.08004 10.6216L5.78671 9.32831C5.59944 9.14081 5.49425 8.88664 5.49425 8.62164C5.49425 8.35664 5.59944 8.10247 5.78671 7.91497C5.97421 7.72771 6.22837 7.62252 6.49337 7.62252C6.75837 7.62252 7.01254 7.72771 7.20004 7.91497L8.50004 9.20831L9.80004 7.91497C9.98754 7.72771 10.2417 7.62252 10.5067 7.62252C10.7717 7.62252 11.0259 7.72771 11.2134 7.91497C11.4006 8.10247 11.5058 8.35664 11.5058 8.62164C11.5058 8.88664 11.4006 9.14081 11.2134 9.32831L9.92004 10.6216L11.2134 11.915H11.2067Z",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1785_3801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.288574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowStatusProblem);
export default __webpack_public_path__ + "static/media/workflow-status-problem.789b6baee2a8df0b01ddfa9c61d45e79.svg";
export { ForwardRef as ReactComponent };